import gql from 'graphql-tag';

export default gql`
    query GetDetailsForStageSheet($stageSheetId: Int) {
        getDetailsForStageSheet(stageSheetId: $stageSheetId) {
            wellheadStages
            jobId
            wellName
            stageStatus {
                stageId
                status
                wellHead
            }
        }
    }
`;
